import React from 'react';
import { Button } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

function CopyButton({ textToCopy, showToast }) {
  const handleCopy = async () => {
    if (!navigator.clipboard) {
        showToast('Clipboard API not available.', 'error');
        return;
    }
    try {
      await navigator.clipboard.writeText(textToCopy);
      showToast('Improved prompt copied to clipboard!', 'success');
    } catch (err) {
      showToast('Failed to copy prompt.', 'error');
      console.error('Failed to copy: ', err);
    }
  };

  return (
    <Button
      variant="contained"
      color="secondary"
      startIcon={<ContentCopyIcon />}
      onClick={handleCopy}
      disabled={!textToCopy}
    >
      Copy Improved Prompt
    </Button>
  );
}

export default CopyButton;